import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';
import { competitionAverageSelectedCompetitionsAtom as playerCompetitionAverageSelectedCompetitionsAtom } from '@/atoms/filters/player/playerCompetitionAverageFilters';
import { competitionAverageSelectedCompetitionsAtom as teamCompetitionAverageSelectedCompetitionsAtom } from '@/atoms/filters/team/teamCompetitionAverageFilters';
import { unwrappedSelectedPlayerNameAtom } from '@/atoms/player/info';
import { unwrappedPlayerComparisonDisplayNameAtom } from '@/atoms/queries/player/playerComparisonInfo';
import { unwrappedComparisonTeamNameAtom } from '@/atoms/queries/team/teamComparison';
import { comparisonIdAtom } from '@/atoms/queryParams';
import { unwrappedSelectedTeamNameAtom } from '@/atoms/team/info';
import { useIsCompetitionAverageMode } from '@/hooks/useIsCompetitionAverageMode';

export const useExportTitle = (): string => {
  const { t } = useTranslation(['navigation', 'export']);
  const isRadarPage = !!useMatch('/:locale/:entity/:entityId/radar/*');
  const isPlayerSection = useMatch('/:locale/player/*');
  const isTeamSection = useMatch('/:locale/team/*');
  const isCompetitionAverageMode = useIsCompetitionAverageMode();
  const playerName = useAtomValue(unwrappedSelectedPlayerNameAtom);
  const teamName = useAtomValue(unwrappedSelectedTeamNameAtom);
  const comparisonId = useAtomValue(comparisonIdAtom);
  const comparisonPlayerName = useAtomValue(unwrappedPlayerComparisonDisplayNameAtom);
  const comparisonTeamName = useAtomValue(unwrappedComparisonTeamNameAtom);
  const playerCompetitionAverageCompetitions = useAtomValue(playerCompetitionAverageSelectedCompetitionsAtom);
  const teamCompetitionAverageCompetitions = useAtomValue(teamCompetitionAverageSelectedCompetitionsAtom);

  const primaryName = isPlayerSection ? playerName : teamName;
  const competitionAverageCompetitions = isPlayerSection
    ? playerCompetitionAverageCompetitions
    : teamCompetitionAverageCompetitions;
  const competitionName = competitionAverageCompetitions[0]?.label ?? '';
  const entityComparisonName = isPlayerSection ? comparisonPlayerName : comparisonTeamName;
  const comparisonName = isCompetitionAverageMode ? competitionName : entityComparisonName;
  const isComparisonRadar = isRadarPage && (!!comparisonId || isCompetitionAverageMode);
  if (isPlayerSection || isTeamSection) {
    return isComparisonRadar
      ? t('comparisonTitle', { ns: 'export', primaryName, comparisonName, interpolation: { escapeValue: false } })
      : primaryName;
  }

  return t('crossPlatform.primary.explore', { ns: 'navigation' });
};
